module.exports = __webpack_public_path__ + "img/users-plan-admin.1c5c6d62.svg";